import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-one-two',
  templateUrl: './c4-four-one-two.component.html',
  styleUrls: ['./c4-four-one-two.component.scss']
})
export class C4FourOneTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
